import React from "react";
const BenificeryEnterby = () => {
  return (
    <div className="program-selection-sectionn margin-lr">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="m-0" style={{ fontWeight: 600 }}>
          NCD Beneficiaries List
        </h3>
        <div className="d-flex ncd_padding">
          <input
            type="text"
            className="form-control me-2 mt-3"
            placeholder="Search by Name, Symp......"
          />
          <button className="Save-btn">Search</button>
        </div>
      </div>
      <div className="table-container mb-50">
        <table className="table-th-box">
          <tbody>
            <tr>
              <td>
                <img src={"/images/benificaryicon.svg"} alt="NCD" className="circular-img" />
              </td>

              <td>
                <span className="font-weight">Raju Kumar</span> <p>30 | M</p>
              </td>

              <td>
                <span className="font-weight">Village</span>
                <p>Bangal</p>
              </td>

              <td>
                <span className="font-weight">Mobile No</span>
                <p>9999XXXXXX</p>
              </td>

              <td>
                <span className="font-weight">Created By:</span>
                <p>Cho21531</p>
              </td>
              <td>
                <button type="button" className="Save-btn   ">
                  <i className="fa fa-paper-plane" aria-hidden="true"></i>

                </button>
              </td>
            </tr>
            <tr>
              <td>
                <img src={"/images/benificaryicon.svg"} alt="NCD" className="circular-img" />
              </td>

              <td>
                <span className="font-weight">Raju Kumar</span> <p>30 | M</p>
              </td>

              <td>
                <span className="font-weight">Village</span>
                <p>Bangal</p>
              </td>
              <td>
                <span className="font-weight">Mobile No</span>
                <p>9999XXXXXX</p>
              </td>
              <td>
                <span className="font-weight">Created By:</span>
                <p>Cho21531</p>
              </td>
              <td>
                <button type="button" className="Save-btn   ">
                  <i className="fa fa-paper-plane" aria-hidden="true"></i>

                </button>
              </td>
            </tr>
            <tr>
              <td>
                <img src={"/images/benificaryicon.svg"} alt="NCD" className="circular-img" />
              </td>

              <td>
                <span className="font-weight">Raju Kumar</span> <p>30 | M</p>
              </td>

              <td>
                <span className="font-weight">Village</span>
                <p>Bangal</p>
              </td>
              <td>
                <span className="font-weight">Mobile No</span>
                <p>9999XXXXXX</p>
              </td>
              <td>
                <span className="font-weight">Created By:</span>
                <p>Cho21531</p>
              </td>
              <td>
                <button type="button" className="Save-btn   ">
                  <i className="fa fa-paper-plane" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BenificeryEnterby;
